// @flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import { Button } from 'gestalt';
import DidItButtonModalManager, {
  type DidItButtonProps,
} from 'app/common/react/components/DidItButtonModalManager';

type Props = {|
  aggregatedPinDataId: string,
  isDoneByMe: boolean,
  loggedInUser: {
    username: string,
    id: string,
  },
  onDoneStateChanged: (stateChanged: boolean) => void,
  pinId: string,
  pinTitle: string,
|};

export function DidItSuggestionCreateButton(props: Props) {
  return (
    <DidItButtonModalManager
      thriftComponentType={PCONST.thrift.ComponentType.USER_DID_IT_ACTIVITY}
      {...props}
    >
      {({ onTriedItButtonClick }: DidItButtonProps) => (
        <Button
          onClick={({ event }) => onTriedItButtonClick(event)}
          text={i18n._('Add', 'Add a try to a pin')}
          disabled={props.isDoneByMe}
          inline
        />
      )}
    </DidItButtonModalManager>
  );
}

export default DidItSuggestionCreateButton;
